import React from "react";
import PropTypes from "prop-types";

const SearchBox = ({ value, onChange }) => (
  <div className="mb-2 position-relative">
    <input
      type="text"
      className="form-control"
      placeholder="Search entries..."
      value={value}
      onChange={e => onChange(e.currentTarget.value)}
    />
    {value && (
      <span
        className="clickable"
        style={{ position: "absolute", right: 8, top: 6 }}
        onClick={() => onChange("")}
      >
        <i className="fa fa-times" aria-hidden="true"></i>
      </span>
    )}
  </div>
);

SearchBox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SearchBox;
